import { useGetAbApiDataQuery } from '@/src/api/rtkQuery/abApi'
import { useMemo } from 'react'
import { isInternalUser } from '@/src/utils/generalUtils/checkUserLogin'
import { DOMAIN } from '../constants/domain'
import { featureConfig } from '../utils/featureConfig'
import { VARIANT } from '../utils/buildUtils'

// Hook to determine sign-in flow variant ('otp' | 'old') based on AB API response
// Cleartrip: always old flow. Internal users (cleartrip/flyin.com emails) get OTP flow on Flyin.
export const useSignInFlowVariant = () => {
    const { data: abApiData } = useGetAbApiDataQuery()
    const { OLD_SIGNIN_FLOW } = featureConfig[VARIANT];
    const variant = useMemo(() => {
        // Cleartrip: force old sign-in flow (no OTP)
        if (OLD_SIGNIN_FLOW) {
            return 'old'
        }

        // Internal users always get OTP flow
        if (DOMAIN === 'https://ae.flyin.com') {
            return 'otp'
        }
        if (typeof window !== 'undefined' && isInternalUser()) {
            return 'otp'
        }

        if (!abApiData) {
            return 'old'
        }

        // 'a' = OTP flow, 'b' = old email/password flow
        const signInFlow = abApiData.signInFlow

        if (signInFlow === 'b') {
            return 'otp'
        }

        return 'old'
    }, [abApiData])

    return {
        variant
    }
}

export default useSignInFlowVariant
